import {createSubscribableReducer} from 'web-app/react/hooks/create-subscribable-reducer';

import {reducer} from './hook-reducer';

export const {useSubscribableReducer: useSubscribableFileTaggingReducer, useSubscription: useSubscribeFileTagging} =
    createSubscribableReducer(reducer);
